
import {validationMixin} from 'vuelidate';
import { required, numeric, helpers } from 'vuelidate/lib/validators'

export default {
    mixins: [validationMixin],
    methods: { 
        triggerValidation() {
            this.$v.valueModel.$touch();
        }
    },
    computed: {
        errors(){
            const errors = [];

            if(!this.$v.valueModel.numberValid) errors.push(sprintf(this.invalidNumberError, this.valueModel))
            if(!this.$v.valueModel.dateValid) errors.push(sprintf(this.invalidDateError, this.valueModel))
            if(!this.$v.valueModel.dateAfterToday) errors.push(sprintf(this.dateInPastError, this.valueModel))
            if(!this.$v.valueModel.requiredIf) errors.push(sprintf(this.requiredError, this.typeModel.label))
            if(!this.$v.valueModel.dropdownValid) errors.push(sprintf(this.dropdownError, this.valueModel))

            return errors;
        },
        isValid() {
            return !this.$v.$invalid;
        },
        showError() {
            return this.$v.valueModel.$dirty && !this.isValid;
        },
        dropdownValueValid() {
            if(!this.isDropdown) return true;

            if(this.valueModel !== undefined) {
                return this.selectedType.dropdownValues.some((value) => value.id === this.valueModel);
            }

            return true;
        },
        dateNotEmpty() {
            return this.valueType === 'date' && this.valueModel !== '' && this.valueModel != undefined;
        }
    },
    validations: {
        valueModel: {
            numberValid: function() {
                if(this.valueType === 'integer') {
                    return numeric.apply(this, arguments);
                }
                return true;
            },
            dateValid: function() {
                if(this.dateNotEmpty) {

                    const inputDate = moment(this.valueModel, 'DD-MM-YYYY', true);
                    return inputDate.isValid();
                }
                return true;
            },
            dateAfterToday: function() {
                if(this.dateNotEmpty) {
                    if(this.$v.valueModel.dateValid) {
                        const input = moment(this.valueModel, 'DD-MM-YYYY', true);
                        const today = moment().startOf('day');
    
                        return input.isAfter(today) || input.isSame(today);
                    }
                }
                return true;
            },
            requiredIf: function() {
                if(this.isRequired) {
                   return required.apply(this, arguments);
                }
                return true;
            },
            dropdownValid: function() {
                if(this.isDropdown) {
                    return this.dropdownValueValid;
                }
                return true;
            }
        }
    },
    data() {
        return {
            dropdownError: this.resource('JourneyBuilder_CustomFields_DropdownValue_NotAvailable_ErrorMessage'),
            requiredError: this.resource('JourneyBuilder_CustomFields_Required_ErrorMessage'),
            invalidDateError: this.resource('JourneyBuilder_CustomFields_InvalidDate_ErrorMessage'),
            invalidNumberError: this.resource('JourneyBuilder_CustomFields_InvalidNumber_ErrorMessage'),
            dateInPastError: this.resource('JourneyBuilder_CustomFields_DropdownValue_DateInPast_ErrorMessage')
        }
    }
}